import { doctorLabelOptions } from '@/lib/labelTaxonomy';

export function classCountsFromAnnotations(annotations: { label: string }[]): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const ann of annotations) {
    const key = ann.label || 'Unlabeled';
    counts[key] = (counts[key] || 0) + 1;
  }
  return counts;
}

export function buildClassCountRows(counts: Record<string, number>) {
  return doctorLabelOptions().map((opt) => ({
    value: opt.value,
    label: opt.label,
    color: opt.color,
    count: counts[opt.value] || 0,
  })).filter((row) => row.count > 0);
}
